import { createReducer } from '@reduxjs/toolkit';
import type { IHeaderImageMetaData, ILanguage, IProduct, ISettings } from '../../api/domain';
import {
    fetchLanguagesSuccess,
    fetchProducts,
    fetchProductsFailure,
    fetchProductsSuccess,
    fetchSettingsSuccess,
    setHeaderImageMetaData,
    setSettingsInitialized,
} from './settings-api-actions';

interface ISettingsApiState {
    settings?: ISettings;
    headerImageMetaData?: IHeaderImageMetaData;
    languages: ILanguage[];
    initialized: boolean;
    products: IProduct[];
    isFetchingProducts: boolean;
}
export type { ISettingsApiState };

export const initialState: ISettingsApiState = { initialized: false, languages: [], products: [], isFetchingProducts: false };

export const settingsApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setSettingsInitialized, (state) => {
            state.initialized = true;
        })
        .addCase(fetchSettingsSuccess, (state, { payload: settings }) => {
            state.settings = settings;
        })
        .addCase(setHeaderImageMetaData, (state, { payload: headerImageMetaData }) => {
            state.headerImageMetaData = headerImageMetaData;
        })
        .addCase(fetchProducts, (state) => {
            state.isFetchingProducts = true;
        })
        .addCase(fetchProductsSuccess, (state, { payload: { products } }) => {
            state.products = products;
            state.isFetchingProducts = false;
        })
        .addCase(fetchProductsFailure, (state) => {
            state.isFetchingProducts = false;
        })
        .addCase(fetchLanguagesSuccess, (state, { payload: languages }) => {
            state.languages = languages;
        });
});
